import {
    AXN_ADMIN_USER_ID_PATTERN,
    AXN_COMPANY_ID_PATTERN,
    AXN_ORGANIZATION_ID_PATTERN,
    AXN_RELYING_PARTY_ID_PATTERN,
    EMAIL_TEMPLATE_ID_PATTERN,
    MESSAGING_TEMPLATE_ID_PATTERN,
    POLICY_COMPONENT_ID_PATTERN,
    SERVICE_TEMPLATE_ID_PATTERN,
    WORKFLOW_ID_PATTERN
} from "@constants/url-parameter-patterns";

const alertsPrefix = "/alerts";
const serviceConfigurationPrefix = "/service-configuration";
const rpServiceConfigPrefix = "/rpservice-config";
const managementConsolePrefix = "/management-console";
const axnadminCorePrefix = "/axnadmin-core";
const idpConfigurationPrefix = "/idp-configuration";
const reportsPrefix = "/reports";

export const apiRoutes = {
    alerts: {
        alertEvent: {
            search: `${alertsPrefix}/alert-event`,
            referenceData: `${alertsPrefix}/alert-event/reference-data`
        },
        referenceData: `${alertsPrefix}/reference-data`
    },
    axnadminCore: {
        authenticateUser: `${axnadminCorePrefix}/authenticate-user`,
        resetUserPasswordWithEmail: `${axnadminCorePrefix}/user/reset/auth0/:userEmail`,
        axn: {
            referencedata: {
                organization: {
                    archive: `${axnadminCorePrefix}/axn/referencedata/company/archive/:${AXN_ORGANIZATION_ID_PATTERN}`,
                    delete: `${axnadminCorePrefix}/axn/referencedata/company/perm-archive/:${AXN_ORGANIZATION_ID_PATTERN}`,
                    restore: `${axnadminCorePrefix}/axn/referencedata/company/restore/:${AXN_ORGANIZATION_ID_PATTERN}`,
                },
                relyingparty: {
                    archive: `${axnadminCorePrefix}/axn/referencedata/relyingparty/archive/:${AXN_RELYING_PARTY_ID_PATTERN}`,
                    delete: `${axnadminCorePrefix}/axn/referencedata/relyingparty/perm-archive/:${AXN_RELYING_PARTY_ID_PATTERN}`,
                    restore: `${axnadminCorePrefix}/axn/referencedata/relyingparty/restore/:${AXN_RELYING_PARTY_ID_PATTERN}`
                }
            },
            relyingparty: `${axnadminCorePrefix}/axn/relyingparty`,
            relyingpartyWithId: `${axnadminCorePrefix}/axn/relyingparty/:relyingPartyId`
        },
        axnadmin: {
            users: `${axnadminCorePrefix}/axnadmin/users`,
            userWithId: `${axnadminCorePrefix}/axnadmin/user/:axnAdminUserId`,
            invitationWithId: `${axnadminCorePrefix}/axnadmin/user/invitation/:axnAdminUserInvitationId`
        },
        data: {
            axnadminuserinvitation: `${axnadminCorePrefix}/data/axnadminuserinvitation`,
            axnadminuserinvitationWithId: `${axnadminCorePrefix}/data/axnadminuserinvitation/:axnAdminUserInvitationId`,
            axnadminuserWithId: `${axnadminCorePrefix}/data/axnadminuser/:axnAdminUserId`,
            axnattributelabel: `${axnadminCorePrefix}/data/axnattributelabel`,
            axnattributelabelWithId: `${axnadminCorePrefix}/data/axnattributelabel/:axnAttributeLabelId`,
            axncompany: `${axnadminCorePrefix}/data/axncompany`,
            axncompanyWithId: `${axnadminCorePrefix}/data/axncompany/:${AXN_COMPANY_ID_PATTERN}`,
            emailTemplate: `${axnadminCorePrefix}/data/selfserviceverificationemailtemplate`,
            emailTemplateWithId: `${axnadminCorePrefix}/data/selfserviceverificationemailtemplate/:${EMAIL_TEMPLATE_ID_PATTERN}`,
        },
        logOut: `${axnadminCorePrefix}/log-out`,
        messagingTemplate: `${axnadminCorePrefix}/messagingTemplate`,
        messagingTemplateWithId: `${axnadminCorePrefix}/messagingTemplate/:${MESSAGING_TEMPLATE_ID_PATTERN}`,
        organizationConfigWithId: `${axnadminCorePrefix}/organization-config/:${AXN_COMPANY_ID_PATTERN}`,
        referenceData: `${axnadminCorePrefix}/reference-data`,
        session: `${axnadminCorePrefix}/session`,
        user: {
            invitation: `${axnadminCorePrefix}/axnadmin/user/invitation`,
            archive: `${axnadminCorePrefix}/user/archive/:${AXN_ADMIN_USER_ID_PATTERN}`,
            restore: `${axnadminCorePrefix}/user/restore/:${AXN_ADMIN_USER_ID_PATTERN}`,
            delete: `${axnadminCorePrefix}/user/perm-archive/:${AXN_ADMIN_USER_ID_PATTERN}`
        },
        users: `${axnadminCorePrefix}/users`
    },
    idpConfiguration: {
        data: {
            identityProviderChangeRequest: `${idpConfigurationPrefix}/data/identityProviderChangeRequest`
        },
        identityProviderConfig: {
            axn: {
                identityProviderWithId: `${idpConfigurationPrefix}/identity-provider-config/axn/identity-provider/:identityProviderId`
            },
            axnAdmin: {
                identityProviderWithId: `${idpConfigurationPrefix}/identity-provider-config/axnAdmin/identity-provider/:identityProviderId`
            },
            changeRequest: {
                identityProvider: {
                    add: `${idpConfigurationPrefix}/identity-provider-config/change-request/identity-provider/add`,
                    createChangeRequest: `${idpConfigurationPrefix}/identity-provider-config/change-request/identity-provider/modify/:identityProviderId`,
                    updateChangeRequest: `${idpConfigurationPrefix}/identity-provider-config/change-request/identity-provider/:identityProviderId/status/:changeRequestStatus`
                }
            },
            details: {
                referenceData: `${idpConfigurationPrefix}/identity-provider-config/details/referencedata`
            },
            identityProvider: {
                export: `${idpConfigurationPrefix}/identity-provider-config/identity-provider/:identityProviderId/export`
            },
            identityProviders: `${idpConfigurationPrefix}/identity-provider-config/identity-providers`,
            list: {
                referenceData: `${idpConfigurationPrefix}/identity-provider-config/list/referencedata`
            }
        },
        referenceData: `${idpConfigurationPrefix}/reference-data`
    },
    managementConsole: {
        axn: {
            cache: {
                refresh: {
                    all: `${managementConsolePrefix}/axn/cache/refresh/all`
                }
            },
            config: {
                refresh: {
                    all: `${managementConsolePrefix}/axn/config/refresh/all`
                }
            },
            sessions: {
                active: `${managementConsolePrefix}/axn/sessions/active`
            }
        },
        axnadmin: {
            security: {
                ruleWithId: `${managementConsolePrefix}/axnadmin/security/rule/:axnAdminSecurityRuleId`,
                rules: `${managementConsolePrefix}/axnadmin/security/rules`
            },
            sessions: {
                active: `${managementConsolePrefix}/axnadmin/sessions/active`
            }
        },
        referenceData: `${managementConsolePrefix}/reference-data`
    },
    reports: {
        activityLogs: `${reportsPrefix}/activity-logs`,
        adaptiveAuthentication: {
            referenceData: `${reportsPrefix}/adaptive-authentication/reference-data`,
            results: `${reportsPrefix}/adaptive-authentication-results`
        },
        assertionFraud: {
            export: `${reportsPrefix}/assertion-fraud/export`,
            referenceData: `${reportsPrefix}/assertion-fraud/reference-data`,
            results: `${reportsPrefix}/assertion-fraud`
        },
        dashboard: {
            summary: `${reportsPrefix}/dashboard-summary`,
            verificationCounts: `${reportsPrefix}/dashboard-verification-counts`,
            verificationServices: `${reportsPrefix}/dashboard-verification-services`,
            verificationTransactions: `${reportsPrefix}/dashboard-verification-transactions`,
        },
        monthlyUsers: {
            referenceData: `${reportsPrefix}/monthly-users/reference-data`,
            results: `${reportsPrefix}/monthly-users`
        },
        referenceData: `${reportsPrefix}/reference-data`,
        serviceAssertionPerformance: {
            referenceData: `${reportsPrefix}/service-assertion-performance-reference-data`,
            results: `${reportsPrefix}/service-assertion-performance`
        },
        serviceAssertionPerformanceComparison: {
            referenceData: `${reportsPrefix}/service-assertion-performance-reference-data`,
            results: `${reportsPrefix}/service-assertion-performance-comparison`
        },
        verificationTransaction: {
            transactionWithId: `${reportsPrefix}/verification-transaction/:transactionId`
        },
        verificationTransactions: {
            results: `${reportsPrefix}/verification-transactions`
        },
        workflowReport: {
            passRates: `${reportsPrefix}/workflow/report/pass-rates`,
            passRatesOverTime: `${reportsPrefix}/workflow/report/pass-rates-over-time`,
            completionRates: `${reportsPrefix}/workflow/report/completion-rates`,
            completionRatesOverTime: `${reportsPrefix}/workflow/report/completion-rates-over-time`,
            stepByStep: `${reportsPrefix}/workflow/report/step-by-step`,
            fraud: `${reportsPrefix}/workflow/report/fraud`,
            volumesByAppID: `${reportsPrefix}/workflow/report/volume-by-app`,
            volumesByCountry: `${reportsPrefix}/workflow/report/volume-by-country`,
            metadata: `${reportsPrefix}/workflow/report/metadata`
        },
        workflowUsageDetails: {
            referenceData: `${reportsPrefix}/workflow/reference-data`,
            workflowResultsDetails: `${reportsPrefix}/workflow-results-details`,
            workflowSankeyResults: `${reportsPrefix}/workflow-highcharts-sankey-results`
        }
    },
    serviceConfiguration: {
        affectedPolicies: `${serviceConfigurationPrefix}/affected-policies/:${POLICY_COMPONENT_ID_PATTERN}`,
        resource: {
            upload: `${serviceConfigurationPrefix}/resource/upload`
        },
        referenceData: `${serviceConfigurationPrefix}/reference-data`,
        workflow: {
            copy: `${serviceConfigurationPrefix}/workflow/copy`,
            archive: `${serviceConfigurationPrefix}/workflow/archive/:${WORKFLOW_ID_PATTERN}`,
            restore: `${serviceConfigurationPrefix}/workflow/restore/:${WORKFLOW_ID_PATTERN}`,
            delete: `${serviceConfigurationPrefix}/workflow/perm-archive/:${WORKFLOW_ID_PATTERN}`,
            export: `${serviceConfigurationPrefix}/workflow`,
        },
        deployedPolicyComponents: `${serviceConfigurationPrefix}/deployedPolicyComponents`,
        deployedPolicyComponentWithId: `${serviceConfigurationPrefix}/deployedPolicyComponent/:${POLICY_COMPONENT_ID_PATTERN}`,
        data: {
            axnrpservice: `${serviceConfigurationPrefix}/data/axnrpservice`,
            appliedProfileWithWorkflowId: `${serviceConfigurationPrefix}/data/axnAppliedProfile`,
            profileproperties: `${serviceConfigurationPrefix}/data/axnProfile/:profileId`,
            rpServiceChangeRequest: `${serviceConfigurationPrefix}/data/rpServiceChangeRequest`,
            serviceTemplate: `${serviceConfigurationPrefix}/data/rpServiceTemplate`,
            serviceTemplateWithId: `${serviceConfigurationPrefix}/data/rpServiceTemplate/:${SERVICE_TEMPLATE_ID_PATTERN}`,
            workflowChangeRequest: `${serviceConfigurationPrefix}/data/workflowChangeRequest`,
            workflowTemplate: `${serviceConfigurationPrefix}/data/workflowTemplate`,
            workflowTemplateWithId: `${serviceConfigurationPrefix}/data/workflowTemplate/:workflowTemplateId`,
            deployedpolicycomponent: `${serviceConfigurationPrefix}/data/deployedpolicycomponent`,
            deployedPolicyComponentWithId: `${serviceConfigurationPrefix}/data/deployedPolicyComponent/:${POLICY_COMPONENT_ID_PATTERN}`
        },
        organization: {
            login: {
                preference: `${axnadminCorePrefix}/organization/login/preference`
            }
        },
        workflows: `${serviceConfigurationPrefix}/workflows`,
        axnadmin: {
            config: {
                refresh: {
                    all: `${serviceConfigurationPrefix}/axnadmin/config/refresh/all`
                }
            },
            log4j: {
                config: {
                    refresh: {
                        all: `${serviceConfigurationPrefix}/axnadmin/log4j/config/refresh/all`
                    }
                }
            },
            security: {
                rules: {
                    refresh: {
                        all: `${serviceConfigurationPrefix}/axnadmin/security/rules/refresh/all`
                    }
                }
            }
        },
        cache: {
            refresh: `${serviceConfigurationPrefix}/cache/refresh`
        },
        rpServiceConfig: {
            axn: {
                rpService: `${serviceConfigurationPrefix}${rpServiceConfigPrefix}/axn/rpservice/:rpServiceId`
            },
            axnAdmin: {
                rpService: `${serviceConfigurationPrefix}${rpServiceConfigPrefix}/axnAdmin/rpservice/:rpServiceId`
            },
            workflow: {
                addService: `${serviceConfigurationPrefix}${rpServiceConfigPrefix}/workflow/:workflowId/rpservice/add`
            },
            changeRequest: {
                rpService: {
                    add: `${serviceConfigurationPrefix}${rpServiceConfigPrefix}/change-request/rpservice/add`,
                    createChangeRequest: `${serviceConfigurationPrefix}${rpServiceConfigPrefix}/change-request/rpservice/modify/:rpServiceId`,
                    updateChangeRequest: `${serviceConfigurationPrefix}${rpServiceConfigPrefix}/change-request/rpservice/:rpServiceId/status/:changeRequestStatus`
                },
            },
            rpService: {
                archive: `${serviceConfigurationPrefix}${rpServiceConfigPrefix}/rpservice/archive/:rpServiceId`,
                delete: `${serviceConfigurationPrefix}${rpServiceConfigPrefix}/rpservice/perm-archive/:rpServiceId`,
                export: `${serviceConfigurationPrefix}${rpServiceConfigPrefix}/rpservice/:rpServiceId/export`,
                import: `${serviceConfigurationPrefix}${rpServiceConfigPrefix}/rpservice/:rpServiceId/import`,
                restore: `${serviceConfigurationPrefix}${rpServiceConfigPrefix}/rpservice/restore/:rpServiceId`
            },
            rpServices: `${serviceConfigurationPrefix}${rpServiceConfigPrefix}/rpservices`,
            validate: `${serviceConfigurationPrefix}${rpServiceConfigPrefix}/validate`
        },
        workflowConfig: {
            axn: {
                workflow: `${serviceConfigurationPrefix}/workflow-config/axn/workflow/:${WORKFLOW_ID_PATTERN}`
            },
            axnAdmin: {
                workflow: `${serviceConfigurationPrefix}/workflow-config/axnAdmin/workflow/:${WORKFLOW_ID_PATTERN}`
            },
            changeRequest: {
                workflow: {
                    createChangeRequest: `${serviceConfigurationPrefix}/workflow-config/change-request/workflow/modify/:${WORKFLOW_ID_PATTERN}`,
                    updateChangeRequest: `${serviceConfigurationPrefix}/workflow-config/change-request/workflow/:${WORKFLOW_ID_PATTERN}/status/:changeRequestStatus`
                }
            },
            validate: `${serviceConfigurationPrefix}/workflow-config/validate`
        },
        selfService: {
            email: `${serviceConfigurationPrefix}/self-service/verification/email`,
            verification: `${serviceConfigurationPrefix}/self-service/verification`
        }
    },
};